import React from 'react';

export const CircleWarningIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
        {...props}
    >
        <circle cx="8" cy="8" r="8" fill="currentColor" />
        <path d="M7.645 10.937l-.42-5.552V1.75h1.54v3.635l-.42 5.552h-.7z" fill="#fff" />
        <ellipse cx="8" cy="12.971" rx="1.25" ry="1.279" fill="#fff" />
    </svg>
);
